<template>

<div class="grid" v-if="count">

	<com-text v-if="item.text" :item="item" />

	<div class="grid-inputs" :class="{'is-multiple': count > 1}">

		<com-input v-for="input in item.inputs" :key="input" :input="inputs[input]" />

	</div>
	
	<com-info v-if="item.info" :info="item.info" />

</div>

</template>

<script>

import comInput from './Input'
import comText from './Text'

export default {

	props: ['item'],

	components: {
		'com-input': comInput,
		'com-text': comText
	},

	computed: {

		count: function() {

			var count = 0

			this.$_.each(this.item.inputs, function(id) {

				if (this.visible(this.inputs[id])) {

					count++

				}

			}.bind(this))

			return count

		}

	}

}

</script>

<style scoped>

.is-mobile .grid {
	padding-top: 16px;
}

.grid-inputs {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}

.is-mobile .grid-inputs {
	flex-direction: column;
}

.grid-inputs >>> .input {
	width: 100%;
}

.grid-inputs.is-multiple >>> .input {
	width: calc(50% - 10px);
}

.is-mobile .grid-inputs.is-multiple >>> .input {
	width: 100%;
}

.grid-inputs.is-multiple >>> .input:nth-child(odd) {
	margin-right: 20px;
}

.is-mobile .grid-inputs.is-multiple >>> .input:nth-child(odd) {
	margin-right: 0px;
}

.grid-inputs.is-multiple >>> .input-label-title {
	font-weight: 100;
}

</style>